window.LH = window.LH || {};

window.LH.ShippingDate = (() => {

    const TIMEZONE = 'America/New_York';

    function formatDate(date, format) {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        switch (format) {
            case 'DD/MM/YYYY':
                return `${day}/${month}/${year}`;

            case 'MMM DD, YYYY':
                return date.toLocaleDateString('en-US', {
                    month: 'short',
                    day: '2-digit',
                    year: 'numeric'
                });

            case 'MM/DD/YYYY':
            default:
                return `${month}/${day}/${year}`;
        }
    }

    function getShippingDate(leadDays = 3, format = 'MM/DD/YYYY') {

        // Current date/time in EST
        const now = new Date();

        const estNow = new Date(
            now.toLocaleString('en-US', {
                timeZone: TIMEZONE
            })
        );

        estNow.setDate(estNow.getDate() + Number(leadDays));

        return formatDate(estNow, format);
    }

    function updateAvailability(inventoryElement) {

        if (!inventoryElement || !inventoryElement.length) return;

        const leadDays = inventoryElement.data('shipping-lead-days') || 3;
        const format = inventoryElement.data('shipping-date-format') || 'MM/DD/YYYY';

        let message = inventoryElement.data('in-stock-message');

        if (!message) return;

        const date = getShippingDate(leadDays, format);

        message = message.replace('{date}', date);

        const value = inventoryElement.find('.productView-info-value');

        const quantity = inventoryElement.data('stock-level') === 'show'
            ? value.text().trim()
            : '';

        value.text(
            quantity ? `${quantity} ${message}` : message
        );

    }

    return {
        getShippingDate,
        updateAvailability
    };

})();